export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/3d4090b24c9044fe6f3189ba3c38e425.jpg";